export default __webpack_public_path__ + "static/media/ellipse.f7049235.png";